import type { IconData } from '@stacksjs/iconify-core'

export const gamma: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12 0a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 2H2v10h10zm-1 1v3H9V5H6v6H4V5H3V3z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export default gamma
